import Routes from './routes';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import muiTheme from './theme/muiTheme';
import ErrorBoundary from './components/ErrorBoundary';

// Seleção dinâmica das URLs de API por ambiente.
// localhost:3000 => APIs locais; qualquer outra origem => APIs de homologação (EXT).
const isLocal = window.location.origin === 'http://localhost:3000';

const urlAgend  = isLocal ? process.env.REACT_APP_LOCAL_URL1 : process.env.REACT_APP_EXT_URL1; // python agend
const urlParsed = isLocal ? process.env.REACT_APP_LOCAL_URL2 : process.env.REACT_APP_EXT_URL2; // python opera
const urlNode   = isLocal ? process.env.REACT_APP_LOCAL_URL3 : process.env.REACT_APP_EXT_URL3; // node
const urlSys    = urlNode; // sys aponta pro node

localStorage.setItem('urlParsed', urlParsed);
localStorage.setItem('urlSys', urlSys);
localStorage.setItem('urlAgend', urlAgend);
localStorage.setItem('urlNode', urlNode);

const App = () => (
  <ThemeProvider theme={muiTheme}>
    <ErrorBoundary>
      <Routes/>
    </ErrorBoundary>
  </ThemeProvider>
);

export default App;
